import {BrowserModule, BrowserTransferStateModule} from '@angular/platform-browser';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

import {CoreModule} from '@core/core.module';
import {SharedModule} from '@shared/shared.module';

import {registerLocaleData} from '@angular/common';

import {AppComponent} from '@app/app.component';

import {environment} from '@env/environment';
import localeNl from '@angular/common/locales/nl';
import * as Raven from 'raven-js';

import {AdminAuthGuard} from '@core/guards/admin-auth.guard';
import {AdminAnonymousGuard} from '@core/guards/admin-anonymous.guard';
import {PublicAuthGuard} from '@core/guards/public-auth.guard';

import {PublicResolver} from '@core/resolvers/public.resolver';

registerLocaleData(localeNl, 'nl-NL');

const routes: Routes = [
    // Redirects from non-existing routes.
    {path: 'admin', redirectTo: '/admin/auth', pathMatch: 'full'},
    {path: 'admin/dashboard', redirectTo: '/admin/dashboard/analytics/videos', pathMatch: 'full'},

    // The admin section.
    {
        path: 'admin',
        children: [
            // The admin authentication section (lazy loaded).
            {
                path: 'auth',
                loadChildren: () => import('@admin/auth/admin-auth.module')
                    .then(m => m.AdminAuthModule),
                canActivate: [AdminAnonymousGuard],
                canActivateChild: [AdminAnonymousGuard]
            },
            // The admin dashboard section (lazy loaded).
            {
                path: 'dashboard',
                loadChildren: () => import('@admin/dashboard/admin-dashboard.module')
                    .then(m => m.AdminDashboardModule),
                canActivate: [AdminAuthGuard],
                canActivateChild: [AdminAuthGuard]
            }
        ]
    },

    {
        path: '',
        resolve: {platform: PublicResolver},
        children: [
            // The front-end public site authentication section (lazy loaded).
            {
                path: 'auth',
                loadChildren: () => import('@public/auth/public-auth.module')
                    .then(m => m.PublicAuthModule)
            },
            // The front-end public site (lazy loaded).
            {
                path: '',
                loadChildren: () => import('@public/pages/public-pages.module')
                    .then(m => m.PublicPagesModule),
                canActivate: [PublicAuthGuard],
                canActivateChild: [PublicAuthGuard]
            }
        ]
    }
];

Raven
    .config('https://0181b82fac5a4c04bd329f3e889d7641@sentry.bravobit.nl/6', {environment: environment.type})
    .install();

export class RavenErrorHandler implements ErrorHandler {

    handleError(error) {
        // If not production don't send the errors.
        if (!environment.production) {
            return;
        }

        // Capture the exception and send it to Sentry.
        Raven.captureException(error);
    }

}

@NgModule({
    imports: [
        SharedModule,
        CoreModule.forRoot(),
        RouterModule.forRoot(routes, {
            paramsInheritanceStrategy: 'always',
            preloadingStrategy: PreloadAllModules,
            initialNavigation: 'enabled'
        }),
        BrowserTransferStateModule,
        BrowserModule.withServerTransition({appId: 'videoplatform-frontend'})
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'nl-NL'},
        {provide: ErrorHandler, useClass: RavenErrorHandler}
    ],
    declarations: [AppComponent],
    bootstrap: [AppComponent]
})
export class AppModule {
}
